import { Component, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { DxButtonComponent, DxValidationGroupComponent } from 'devextreme-angular';
import { BasePageComponent } from '@base/component/BasePageComponent';
import { BaseEntity, BaseState } from '@base/entities/BaseEntities';
import { ResourcesService } from '@core/framework/resources.service';
import { BasePageCRUDComponent } from '@m4u-angular/base/component/BasePageCRUDComponent';
import { BaseEndpointCRUD } from '@m4u-angular/base/endpoint/BaseEndpointCRUD';
import { EnumPageDisplayModes } from '@m4u-angular/core/framework/sysenums.enum';
import { ButtonComponent } from '../../../components/button/button.component';

@Component({
    selector: 'm4u-pagebuttons',
    templateUrl: './pagebuttons.component.html',
    styleUrls: ['./pagebuttons.component.scss']
})
export class PageButtonsComponent {
    constructor(private resources: ResourcesService) { }

    @Input() Page: BasePageComponent<BaseEntity, BaseState> | BasePageCRUDComponent<BaseEntity, BaseState, BaseEndpointCRUD<BaseEntity>>;
    @Input() OKText: string = this.resources.RC('genOK');
    @Input() OKTabIndex: number | undefined;
    @Input() CancelText: string = this.resources.RC('genCancel');
    @Input() ValidationGroup: DxValidationGroupComponent;
    @Input() IsAllow = true;
    @Input() IsCloseOnly: boolean;
    @Input() CustomCloseAction: boolean;
    @Input() Disabled: boolean;
    @Input() CloseButtonHidden: boolean;
    @Input() AutoCloseBottomSheet = true;
    @Output() OnOK = new EventEmitter();
    @Output() OnCancel = new EventEmitter();
    @Output() OnOkValidationFailed = new EventEmitter();

    @ViewChild('okBtn') okBtnRef: ButtonComponent;

    //Handle cancel press
    OnCancelButton() {
        if (!this.CustomCloseAction) {
            this.Page.ClosePage();
            return;
        }
        
        this.OnCancel.emit();
        this.CloseBottomSheet();
    }

    get OkButtonDisabled(): boolean {
        if (this.Disabled) {
            return true;
        }
        //disable ok button for crud pages if no changes
        if (this.Page instanceof BasePageCRUDComponent && !(this.Page as any).OnIsDirtyDisabled()) {
            return !(this.Page as any).IsDirty;
        }
        return false;
    }

    get IsSaving(): boolean {
        if (this.Page instanceof BasePageCRUDComponent) {
            return this.Page.IsSaving;
        }

        return false;
    }

    //Handle OK press
    OnOKButton() {
        //Validate, if validation group was specified
        if (this.ValidationGroup != undefined) {
            this.Page.ValidateValidationGroup(this.ValidationGroup).then(isValid => {
                if (!isValid) {
                    this.OnOkValidationFailed.emit();
                    return;
                }

                this.OnOK.emit();
                this.CloseBottomSheet();
            });
        } else {
            //Emit event
            this.OnOK.emit();
            this.CloseBottomSheet();
        }
    }

    IsCloseButtonHidden() {
        return (this.IsPageShowAsFullScreen() || this.CloseButtonHidden);
    }

    IsPageShowAsFullScreen() {
        return this.Page && this.Page.IsShowAsFullScreen && this.Page.IsShowAsFullScreen();
    }

    CloseBottomSheet() {
        if (this.Page.DisplayMode === EnumPageDisplayModes.BottomSheet && this.AutoCloseBottomSheet) this.Page.ClosePage();
    }

    HasContent(content: any) {
        return content && content.childElementCount > 0;
    }
}